<template>
  <div class="table-wrapper">
    <table 
      :id="id ? id : ''"
      class="table table-striped table-bordered table-sm"
    >
      <thead>
        <tr>
          <template v-for="(header,index) in headers">
            <th :key="index" class="lines" :class="header.style ? 'even-lines' : ''">
              <div v-if="header.has_slot" class="d-flex justify-content-center align-items-center" @click="setSort(header)" :style="header.sortable ? 'cursor:pointer' : ''">
                <slot v-if="header.header_slot" :name="header.header_slot"></slot>
                <span v-else>{{header.text}}</span>
                 <span :style="header.sortable ? 'cursor:pointer' : ''">
                    <i v-if="header.sortable && sort.column !== header.value" class="mdi mdi-unfold-more-horizontal" style="max-height:20px"></i>
                    <i v-if="header.sortable && sort.column == header.value" :class="`mdi ${sort.order == 'asc'? `mdi-chevron-up` : `mdi-chevron-down`} `" style="max-height:20px"></i>
                  </span>
              </div>
              <span v-else @click="setSort(header)" :style="header.sortable ? 'cursor:pointer' : ''" class="th-label">
                {{header.text}}<i v-if="header.sortable && sort.column !== header.value" class="mdi mdi-unfold-more-horizontal"></i><i v-if="header.sortable && sort.column == header.value" :class="`mdi ${sort.order == 'asc'? `mdi-chevron-up` : `mdi-chevron-down`} `"></i>
              </span>
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, idx) in computedList">
          <tr :key="idx">
            <td v-for="(head,i) in headers" :key="i" class="lines" :class="head.style ? 'even-lines' : ''" :style="returnStyles({item,head})">
              <div v-if="head.has_slot" class="d-flex justify-content-center">
                <slot :name="head.value" :item="item"></slot>
              </div>

              <div v-else>
               <span class="d-flex justify-content-center text-center" :class="{'text-nowrap': isShortDate(returnField(item, head))}">{{displayField(returnField(item, head))}}</span>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="dataItems.length < 1" class="table-empty">
        <i class="mdi mdi-table-search"></i>
        Nenhum item encontrado ...
    </div>
    <div class="d-flex justify-end" v-if="showPaginator">
      <v-pagination
        v-model="page"
        class="text-left"
        :length="numberOfPages"
        total-visible="8"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name:"TheTable",
  props:{
    id:String,
    headers:Array,
    dataItems:Array,
    numberOfPages:Number
  },
  data() {
    return {
      page:1,
      sort: {
        column: "",
        type: "",
        order: "",
      },
    }
  },
  methods: {
    // só exibição: "2026-09-26 17:37:02 -0300" (data de emissão crua da API) vira "26-09-2026 17:37"
    displayField(value) {
      const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}:\d{2}):\d{2} [-+]\d{4}$/.exec(String(value));
      return m ? `${m[3]}-${m[2]}-${m[1]} ${m[4]}` : value;
    },
    // datas DD-MM-AAAA não quebram no hífen
    isShortDate(value) {
      return /^\d{2}-\d{2}-\d{4}/.test(String(value)) || /^\d{4}-\d{2}-\d{2} \d{2}:/.test(String(value));
    },
    returnField(item, head) {
      if(head.value.includes(".")) {
        return head.value.split(".").reduce((o, i) => o[i], item);
      } else {
        return item[head.value];
      }
    },
    resolve(path, obj) {
      if (path) {
        return path.split(".").reduce((prev, curr) => {
          return prev ? prev[curr] : null;
        }, obj || self);
      }
    },
    setSort(header) {
      if (header.sortable) {
        if(this.$route.name === "Services-create" || this.$route.name === "Edit-service") {
          this.doSort([],header);
          if(this.sort.order === "") {
            this.sort.order = "asc";
            this.sort.column = header.value;
            this.sort.type = header.type;
          } else {
            this.sort.column = "";
            this.sort.type = "";
            this.sort.order = "";
          }
        } else {
          if (header.value && header.value != this.sort.column) {
            this.sort.column = header.value
            this.sort.type = header.type
            this.sort.order = 'asc'
          } else if (header.value && header.value == this.sort.column && this.sort.order == 'asc') {
            this.sort.order = 'desc'
          } else {
            this.sort.column = ''
            this.sort.type = ''
            this.sort.order = ''
          }
        }
      }
    },
    doSort(data, header) {
      if(this.$route.name === "Services-create" || this.$route.name === "Edit-service") {
        if(this.sort.order === "") {
          this.$emit("sortable", header.value);
        } else {
          this.$emit("sortable");
        }
      } 
      else {
        const dataSort = [...data];
        dataSort.sort( (x, y) => {
          if (!header.type || header.type == 'string') {
            let va = this.resolve(header.column, x), vb = this.resolve(header.column, y)
            let a = va ? va.toUpperCase() : "", b = vb ? vb.toUpperCase() : ""
            if (header.order == 'asc') {
              if (a > b) return  1
              if (a < b) return -1
              if (a == b) return 0
            } else {
              if (b > a) return  1
              if (b < a) return -1
              if (b == a) return 0
            }
          } else if (header.type == 'number' || header.type == 'money') {
            let va = this.resolve(header.column, x), vb = this.resolve(header.column, y)
            let a = va ? va: 0, b = vb ? vb : 0
            return  header.order == 'asc' ? a - b : b - a
          } else if (header.type == 'date' || header.type == 'date2') {
            const s = this.resolve(header.column, x) ? this.resolve(header.column, x).substr(0,10).split('-') : '1970-01-01';
            const e = this.resolve(header.column, y) ? this.resolve(header.column, y).substr(0,10).split('-') : '1970-01-01';
            let a = new Date(s[0], s[1]-1, s[2]), b = new Date(e[0], e[1]-1, e[2]);
            return header.order == 'asc' ? a - b : b - a
          }
        });
        return dataSort
      }  
    },
    invalidThisLine({item,head}) {
      let result = "";
      switch(true) {
        // pesagem com observação fica esmaecida, menos em serviço a refazer (Parcialmente Aprovado/Reprovado)
        case (item.observation && item.observation !== "" && head.value !== "actions" && !head.show_controls && !this.serviceToRedo) :
          result = "opacity:0.5 !important;";
          break;
        case (head.value === "name" && item.error !== undefined) :
          result = "color:red !important; opacity:1 !important;";
          break; 
        case (item.kind_explanation !== undefined && !head.show_controls && !head.approve_switch) :
          result = "opacity:0.5; pointer-events:none !important;";
          break;
        case (head.value === "actions" && head.show_controls) :
          result = "opacity:1; pointer-events:all; !important;";
          break; 
        case (head.value === "actions" && head.sm_size) :
          result = "max-width:50px !important;";
          break;
        default:
          result = "";
        break;
      }
      if(this.$route.name === "Weight-in-create" || this.$route.name === "Edit-service" || this.$route.name === "Services-details" || this.$route.name === "Closures-list") {
        return result;
      } else {
        if(head.styles) {
          return head.styles;
        } else {
          return false;
        }
      }
    },
    returnStyles({item, head}) {
      const invisibleLines = this.invalidThisLine({item, head});
      let widthAdjust = "";
      if(typeof head.style === "string") widthAdjust = head.style;
      return invisibleLines + widthAdjust;
    }
  },
  computed: {
    ...mapState("service", ["service_single"]),
    serviceToRedo() {
      const status = this.service_single && this.service_single.status;
      return status === "Parcialmente Aprovado" || status === "Reprovado";
    },
    showPaginator() {
      return this.numberOfPages ? true : false
    },
    computedList() {
      if(this.$route.name === "Services-create" || this.$route.name === "Edit-service") {
        return this.dataItems;
      } else {
        if(this.sort.column !== "") {
          return this.doSort(this.dataItems, this.sort);
        } else {
          return this.dataItems;
        }
      }
    }
  }
}
</script>

<style scoped>
  .table-wrapper {
    width: 100%;
  }
  .table-wrapper > table {
    --bs-table-accent-bg: transparent;
    --bs-table-striped-bg: transparent;
    border: 1px solid var(--line) !important;
    border-radius: 10px;
    border-collapse: separate;
    border-spacing: 0;
    background: white;
    margin-bottom: 14px;
  }
  /* cantos arredondados nas células (overflow:hidden na tabela cortava os menus de ação das linhas) */
  thead th:first-child { border-top-left-radius: 10px; }
  thead th:last-child { border-top-right-radius: 10px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 10px; }
  tbody tr:last-child td:last-child { border-bottom-right-radius: 10px; }
  thead th {
    text-align: center;
    background: #f6f7fa;
    color: #4b5563;
    font-size: .74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
    border: 0 !important;
    border-bottom: 1px solid var(--line) !important;
    padding: 12px 8px !important;
  }
  tbody td {
    box-shadow: none !important;
    border: 0 !important;
    border-bottom: 1px solid #eff1f5 !important;
    padding: 9px 8px !important;
    font-size: .88rem;
  }
  tbody tr:nth-of-type(odd) {
    background-color: #fbfbfd !important;
  }
  /* linhas entram em cascata curta (só as primeiras, para não atrasar listas longas) */
  tbody tr {
    transition: background-color .12s ease;
    animation: row-in .28s ease-out backwards;
  }
  tbody tr:nth-child(2) { animation-delay: .02s; }
  tbody tr:nth-child(3) { animation-delay: .04s; }
  tbody tr:nth-child(4) { animation-delay: .06s; }
  tbody tr:nth-child(5) { animation-delay: .08s; }
  tbody tr:nth-child(6) { animation-delay: .1s; }
  tbody tr:nth-child(7) { animation-delay: .12s; }
  tbody tr:nth-child(8) { animation-delay: .14s; }
  tbody tr:nth-child(n+9) { animation-delay: .16s; }
  @keyframes row-in {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
  }
  tbody tr:hover {
    background-color: var(--jersey-yellow-soft) !important;
  }
  tbody tr:last-child td {
    border-bottom: 0 !important;
  }
  .th-label {
    display: inline;
  }
  .th-label i {
    font-size: .95rem;
    vertical-align: -1px;
    margin-left: 2px;
  }
  /* campos dentro das células (pesagem, análise) não encolhem a ponto de cortar o valor */
  tbody td ::v-deep .v-input {
    min-width: 56px;
  }
  .table-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 22px 0 26px;
    color: var(--muted);
  }
  .table-empty i {
    font-size: 1.4rem;
    opacity: .7;
  }

  .lines {
    vertical-align: middle;
  }

  .even-lines {
    max-width: 50px !important;
  }

  /* desktop: os títulos das colunas ficam visíveis ao rolar a página, logo abaixo do cabeçalho do sistema
     (em modal e painel lateral, no topo do próprio modal: --table-sticky-top no App.vue) */
  @media screen and (min-width: 1201px) {
    thead th {
      position: sticky;
      top: var(--table-sticky-top, var(--header-height));
      z-index: 2;
    }
  }
  /* telas estreitas: a tabela rola dentro do cartão (no desktop fica sem overflow, para não cortar os menus das linhas) */
  @media screen and (max-width: 1200px) {
    .table-wrapper {
      max-width: 100%;
      overflow-x: auto;
    }
  }
</style>
